module.exports = __webpack_public_path__ + "img/logo_vertical.112a90a2.png";